module.exports = "https://cdn2-fs.clearscore.com/flux/images/c0697672f951be5abec5072a6a683cf8.jpg";